import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/expenseService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import { getLedgerTypes } from "../../services/expenseTypeService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class ExpenseEditForm extends Form {
  state = {
    imageUrl: false,
    data: {
      expense_type_id: "",
      description: "",
      cost: "",
    },
    paymentDate: "",
    visas: [],
    errors: {},
  };

  schema = {
    id: Joi.string(),
    expense_type_id: Joi.number().required().label("Expense Type"),
    description: Joi.string().required().label("Description"),
    cost: Joi.number().required().label("Cost"),
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });
      const { data: visasAccounts } = await getLedgerTypes();
      const visas = [{ id: "", name: "Select" }, ...visasAccounts];
      this.setState({ visas, paymentDate: new Date(account.payment_date) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  handleChangePaymentDate = (date) => {
    this.setState({
      paymentDate: date,
    });
  };

  async componentDidMount() {
    await this.populateAccount();
  }

  mapToViewModel(account) {
    return {
      expense_type_id: account.expense_type_id.id,
      cost: account.cost,
      description: account.description,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      //const data = { ...this.state.data };

      let formData = new FormData();
      formData.append("expense_type_id", this.state.data.expense_type_id);
      formData.append("description", this.state.data.description);
      formData.append("cost", this.state.data.cost);
      formData.append("attachment", this.state.imageUrl);
      formData.append("_method", "PUT");

      var event = new Date(this.state.paymentDate);

      var utcDate = new Date(
        Date.UTC(
          event.getFullYear(),
          event.getMonth(),
          event.getDate(),
          event.getHours(),
          event.getMinutes()
        )
      );

      let date = JSON.stringify(utcDate);
      date = date.slice(1, 11);

      formData.append("payment_date", date);
      formData.append("id", parseInt(ledgerTypeId));

      this.setState({ blocking: true });
      await updateSingle(formData, ledgerTypeId);
      this.setState({ blocking: false });
      toast.success("Expense has been updated successfully.");
      this.props.history.push("/expenses");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.visa_id)
          errors.expense_type_id = ex.response.data.errors.expense_type_id;

        if (ex.response.data.errors.description)
          errors.description = ex.response.data.errors.description;

        if (ex.response.data.errors.cost)
          errors.cost = ex.response.data.errors.cost;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/Expenses.png";
    if (auth.getCurrentUser().role != "company") {
      return "Your are authorized to perform this action.";
    }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update expense</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/expenses")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update expense</h3>
              <p>Provide the information below to update the expense.</p>
              <label>Payment Date</label>
              <br />
              <DatePicker
                selected={this.state.paymentDate}
                onChange={this.handleChangePaymentDate}
                className="input"
              />
              {this.renderSelect(
                "expense_type_id",
                "Select type ",
                this.state.visas
              )}
              {this.renderInput("cost", "Cost", "text")}
              {this.renderInput("description", "Description", "text")}
              <label>Attachment</label>
              <input
                className="input"
                type="file"
                onChange={this.onChangeFile}
              />

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default ExpenseEditForm;
